import React from 'react';
import './style.css';

type ButtonProps = {
    label: string;
    onClick?: () => void;
    type?: 'button' | 'submit' | 'reset';
    disabled?: boolean;
};

const Button: React.FC<ButtonProps> = ({
    label = 'Button',
    onClick,
    type = 'button',
    disabled = false,
}) => {
    return (
        <button
            className="custom-button"
            type={type}
            onClick={onClick}
            disabled={disabled}
        >
            {label}
        </button>
    );
};

export default Button;
